var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonEndLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 38
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1l-9 9v17.79L10 37v1h-.21L0 28.21V9.79L9.79 0h.42z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ButtonEndLeft_svg__fill-on-hover",
    d: "M10 1l-9 9v17.79L10 37z",
    fill: "transparent"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIzOCIgdmlld0JveD0iMCAwIDEwIDM4Ij4KPHBhdGggZD0iTTEwLDEsMSwxMFYyNy43OUwxMCwzN3YxSDkuNzlMMCwyOC4yMVY5Ljc5TDkuNzksMGguNDJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggY2xhc3M9ImZpbGwtb24taG92ZXIiIGQ9Ik0xMCwxLDEsMTBWMjcuNzlMMTAsMzdaIiBmaWxsPSJ0cmFuc3BhcmVudCIvPgo8L3N2Zz4=";
export { SvgButtonEndLeft as ReactComponent };